<div class="footer fixed-bottom" *ngIf="!(_sessionService.isLoggedIn() | async)">
  <div class="row m-0">

    <div class="col-md-5">
      <p class="mt-1 font-weight-bold">Members and Partners</p>
      <img src="../../../../assets/images/level.jpg" class="p-2">
      <img src="../../../../assets/images/innovate_finace.jpg" class="p-2">
      <img src="../../../../assets/images/Microsoft-logo.jpg" class="p-2">
    </div>


    <div class="col-md-6 col-sm-6 col-lg-3">
        <div class="mb-3 mt-1 font-weight-bold">Featured Partner</div>
      <img src="../../../../assets/images/finreg_logo_footer.png">

    </div>
    <div class="col-md-12 col-sm-6 col-lg-3 mt-1">
      <div class="font-weight-bold">About the Services</div>
      <div class="mt-2 small">About utilidex | finance</div>
      <div class="small">Built on microsoft azure</div>
      <div class="small">Terms & conditions</div>
    </div>
    <!-- <div class="col-sm-9 navBarDefaultMarginBottom" style="margin-bottom:0px !important;">
        <div class="members-partner" style="margin-right:10px;">
            <p class="pHeading" style="padding-left:20px; margin:0px;">Members and Partners</p>
            <div class="featured-three">
                <img src="/ContentOld/Theme/Images/Microsoft-logo.jpg" class="img-responsive">
            </div>
            <div class="featured-one" style="height:60px; margin-left:20px !important;">
                <img src="/ContentOld/Theme/Images/level39-220x133.jpg" style="height:40px;" class="img-responsive">
            </div>
            <div class="featured-two" style="margin-left:20px;">
                <img src="/ContentOld/Theme/Images/IF-Primary-Horizontal-Logo-Black-and-Green.jpg" class="img-responsive">
            </div>
        </div>
    </div> -->
  </div>
</div>
